import { render, staticRenderFns } from "./PartnersBoard.vue?vue&type=template&id=1b7f53cf&scoped=true&"
import script from "./PartnersBoard.vue?vue&type=script&lang=js&"
export * from "./PartnersBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f53cf",
  null
  
)

export default component.exports